function _90d_acf_google_map(settings) {

  this.zoom_type = settings.zoom_type;
  this.zoom = settings.zoom;
  this.map_container = 'acf-map-container';
  this.map_element = 'acf-map';
  this.scrollwheel = false;
  this.init = init;
  this.add_markers = add_markers;
  this.directions_init = directions_init;
  this.perspective_init = perspective_init;
  this.rendered_map = '';
  this.main_markers_arr = [];
  this.markers_arr = [];
  this.active_markers = [];
  this.map_groups = document.getElementsByClassName('map-group-filter');
  this.map_menu = document.querySelectorAll('#map_menu>li');
  this.script_embedded = false;
  this.retry_limit  = 8;
  this.retries      = 0;
  this.map_type_id = function () {
    let arr = settings.map_type_id.split(',');
    return arr;
  }
  this.custom_styles = function () {
    let map = document.getElementsByClassName('acf-map')

    for (let i = 0; i < map.length; i++) {

      if (map[i].dataset.mapStyles) {
        return JSON.parse(map[i].dataset.mapStyles);
      } else {
        return []
      }
    }
  }
  let map_obj = this;

  function init() {
    loadGoogleMapsApi();
  };

  // clear all overlays on map
  function clear_map(map, display, directions_panel) {
    var clear_btn = document.getElementById('map-clear');
    clear_btn.addEventListener('click', function () {
      centre_map(map);
      display.setMap(null);
      directions_panel.remove();
    });
  }

  //get the triggers from map-content element

  // Add relevant script tags or fire ready function if scripts exists
  function loadGoogleMapsApi() {
    if (typeof google === "undefined") {
      if(!map_obj.script_embedded) {
        window._90dl_google_maps_api_key = typeof window._90dl_google_maps_api_key === 'undefined' ? 'none' : window._90dl_google_maps_api_key;
        const script = document.createElement("script");
        script.src = "https://maps.googleapis.com/maps/api/js?key=" + window._90dl_google_maps_api_key + "&libraries=places&ver=3";
        script.async = true;
        script.defer = true;
        document.getElementsByTagName("head")[0].appendChild(script);
        map_obj.script_embedded = true;
      }
      if(map_obj.retries < map_obj.retry_limit) {
        setTimeout(function () {
          map_obj.retries++;
          loadGoogleMapsApi();
        }, 600)
      } else {
        console.log("Maps failed to initialise after " + map_obj.retries + " attempts and has stopped.");
      }
    } else {
      loadGoogleMapsApiReady();
    }
  };

  // Fire Google maps Api Ready function
  function loadGoogleMapsApiReady() {

    const maps = document.getElementsByClassName(map_obj.map_element);

    for (let x = 0; x < maps.length; x++) {
      render_map(maps[x]);
    }

  };


  function create_marker(marker_obj, map) {
    let lat_lng = new google.maps.LatLng(marker_obj.lat, marker_obj.lng);

    const map_marker = new google.maps.Marker({
      position: lat_lng,
      map: map,
      icon: marker_obj.icon
    });


    map_obj.active_markers.push(map_marker);
  }


  function create_marker_obj(marker_html) {
    let marker_group = "default";
    if (typeof marker_html.dataset.markerGroup !== 'undefined') {
      marker_group = marker_html.dataset.markerGroup;
    }

    let lat_lng_marker = {
      lat: marker_html.dataset.lat,
      lng: marker_html.dataset.lng,
      icon: marker_html.dataset.icon,
      marker_group: marker_group,
      title: marker_html.dataset.title
    }

    return lat_lng_marker;
  };

  // create marker object 
  function add_markers(marker, map, filter) {
    if (typeof filter === 'undefined') {
      filter = false;
    }
    if (!filter || filter === '_90dl_remove') {
      create_marker(marker, map);
    } else {
      if (marker.marker_group === filter) {
        create_marker(marker, map);
      }
    }

  };

  function filter_map(map, filter) {
    for (var i = 0; i < map_obj.active_markers.length; i++) {
      map_obj.active_markers[i].setMap(null);
    }
    map_obj.active_markers = [];

    for (let i = 0; i < map_obj.main_markers_arr.length; i++) {
      add_markers(map_obj.main_markers_arr[i], map_obj.rendered_map);
    }

    for (let i = 0; i < map_obj.markers_arr.length; i++) {
      add_markers(map_obj.markers_arr[i], map_obj.rendered_map, filter);
    }
    centre_map(map);
  }

  // centre map to available markers
  function centre_map(map) {

    let map_bounds = new google.maps.LatLngBounds();
    if(map_obj.zoom_type === 'fit-to-boundries') {
      for (let i = 0; i < map_obj.active_markers.length; i++) {
        let map_position = new google.maps.LatLng(map_obj.active_markers[i].position.lat(), map_obj.active_markers[i].position.lng());
        map_bounds.extend(map_position);
      }
    } else {
      for (let i = 0; i < map_obj.main_markers_arr.length; i++) {
        let map_position = new google.maps.LatLng(map_obj.main_markers_arr[i].lat, map_obj.main_markers_arr[i].lng);
        map_bounds.extend(map_position);
      }
    }
    if (map_obj.zoom_type === 'fit-to-boundries') {
      map.fitBounds(map_bounds);
    } else {
      map.setCenter(map_bounds.getCenter());
      map.setZoom(map_obj.zoom);
    }
  };

  // settings and rendering of the map
  function render_map(ele) {


    let directions_close_button = document.getElementsByClassName('directions-close-button');
    for (var i = 0; i < directions_close_button.length; i++) {
      directions_close_button[i].addEventListener('click', function (e) {
        document.getElementById('postcode-finder').classList.remove('active');
        let get_buttons = document.getElementsByClassName('get-directions-button');
        for (var i = 0; i < get_buttons.length; i++) {
          get_buttons[i].classList.remove('active')
        }
        e.preventDefault();
      });
    }


    if (map_obj.map_menu) {

      for (var i = 0; i < map_obj.map_menu.length; i++) {
        map_obj.map_menu[i].addEventListener('click', function (e) {
          let menu = map_obj.map_menu;



          if (this.dataset.menuId === 'directions') {
            let directions_button = document.getElementsByClassName('get-directions-button');
            for (var i = 0; i < directions_button.length; i++) {
              document.getElementById('postcode-finder').classList.add('active');

            }
          } else {
            document.getElementById('postcode-finder').classList.remove('active');
          }

          if (typeof this.dataset.mapGroup !== 'undefined') {
            let filter_type = this.dataset.mapGroup;
            filter_map(map_obj.rendered_map, filter_type);
          }

          for (var i = 0; i < menu.length; i++) {
            menu[i].classList.remove('active');
            if (menu[i].dataset.menuId === this.dataset.menuId && this.dataset.menuId !== 'reset') {
              menu[i].classList.add('active');
            }
          }
          e.preventDefault();
        });
      }
    }

    let types = document.getElementsByClassName('map-type-filter');
    for (var i = 0; i < types.length; i++) {
      types[i].addEventListener('click', function (e) {
        let types = document.getElementsByClassName('map-type-filter');
        let that = this;
        let type = this.dataset.mapType;
        for (let i = 0; i < types.length; i++) {
          if (types[i].dataset.mapType === type) {
            that.classList.add('active');
          } else {

            types[i].classList.remove('active');
          }
        }
        map_obj.rendered_map.setMapTypeId(type);
        e.preventDefault();
      });
    }


    const args = {
      zoom: ele.zoom,
      center: new google.maps.LatLng(0, 0),
      scrollwheel: false,
      zoomControl: true,
      zoomControlOptions: {
        position: google.maps.ControlPosition.LEFT_BOTTOM
      },
      mapTypeControl: false,
      scaleControl: true,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
      styles: map_obj.custom_styles(),
    };



    const main_markers = ele.querySelectorAll('.main-marker');
    const markers = ele.querySelectorAll('.additional-marker');
    map_obj.rendered_map = new google.maps.Map(ele, args);

    if (map_obj.map_type_id == 'satellite' && ele.classList.contains('3d-perspective')) {
      map_obj.rendered_map.setTilt(45);
    }

    //Main Markers
    for (let i = 0; i < main_markers.length; i++) {
      let marker_obj = create_marker_obj(main_markers[i]);
      map_obj.main_markers_arr.push(marker_obj);
      add_markers(marker_obj, map_obj.rendered_map);
    }

    //Additional Markers
    for (let i = 0; i < markers.length; i++) {
      let marker_obj = create_marker_obj(markers[i]);
      map_obj.markers_arr.push(marker_obj);
      add_markers(map_obj.markers_arr[i], map_obj.rendered_map);
    }


    map_obj.rendered_map.markers = [];
    centre_map(map_obj.rendered_map);

  };

  function directions_init() {
    setTimeout(function () {
      let map = map_obj.rendered_map;

      let map_markers = map_obj.rendered_map.markers;

      let directions_service = new google.maps.DirectionsService();
      let directions_display = new google.maps.DirectionsRenderer();


      // if(document_panel.length) {
      //   document_panel.remove();
      // }

      directions_display.setMap(map);


      const postcode_input = document.getElementById('postcode-input');
      const postcode_button = document.getElementById('postcode-submit');

      const map_classes = document.getElementsByClassName(map_obj.map_element)[0];

      function process_directions() {

        let directions_display_container = document.getElementsByClassName('directions-display-container');
        if (directions_display_container.length) {
          directions_display.setMap(null);
          for (let i = 0; i < directions_display_container.length; i++) {
            directions_display_container[i].remove();
          }
        }
        directions_display.setMap(map);


        if (postcode_input.value !== '') {

          let lat_val, lng_val, start_point, end_point, request;

          let first_marker = map_obj.main_markers_arr[0];



          lat_val = parseFloat(first_marker.lat);
          lng_val = parseFloat(first_marker.lng);

          start_point = postcode_input.value;
          end_point = new google.maps.LatLng(lat_val, lng_val);

          // Build a request for the Directions API
          request = {
            origin: start_point,
            destination: end_point,
            provideRouteAlternatives: true,
            travelMode: 'DRIVING',
            unitSystem: google.maps.UnitSystem.IMPERIAL
          };

          let directions_display_container = document.createElement('div');
          directions_display_container.className = "directions-display-container";

          let message = document.createElement('p');
          message.className = 'directions-error';

          let country;
          let geocoder = new google.maps.Geocoder();

          geocoder.geocode({
            'address': postcode_input.value
          }, function (results, status) {

            let map_container = document.getElementsByClassName(map_obj.map_container)[0];
            let postcode_messages = document.getElementById("postcode-messages");
            postcode_messages.innerHTML = "";


            if (status == 'OK') {

              var address_parts = results[0].address_components.filter(function (address_parts) {

                return address_parts.short_name === 'GB' || address_parts.short_name === 'ENGLAND' || address_parts.short_name === 'SCOTLAND' || address_parts.short_name === 'WALES';
              })[0];

              if (typeof address_parts != 'undefined') {

                //we should be in UK
                directions_service.route(request, function (result, status) {

                  //Check API response is OK
                  if (status == 'OK') {

                    message.innerHTML = 'Estimate driving time: ' + result.routes[0].legs[0].duration.text;
                    directions_display.setDirections(result);
                    message.innerHTML = '<a id="map-clear" class="button small">Clear Map</a>';
                    document.getElementById('directions_display').appendChild(directions_display_container);
                    directions_display_container.appendChild(message);

                    if (map_classes.classList.contains('directions-waypoints')) {
                      show_directions(result, map, directions_display, directions_display_container);
                    }

                  } else if (status == 'ZERO_RESULTS') {
                    postcode_messages.innerText = 'No results found - please try again';
                    //directions_display_container.appendChild(message);
                  }
                });
              } else {
                postcode_messages.innerHTML = 'You appear to have entered an incorrect/non-UK postcode, please try again';
                //directions_display_container.appendChild(message);
              }
            } else {
              postcode_messages.innerHTML = 'You appear to have entered an incorrect postcode, please try again';
              //directions_display_container.appendChild(message);
            }
          });
        }
      }

      postcode_button.addEventListener('click', process_directions);

      postcode_input.addEventListener('keypress', function (e) {
        var key = e.which || e.keyCode;
        if (key === 13) {
          process_directions();
        }
      });

    }, 200)

  };

  function show_directions(result, map, display, container) {
    if (typeof container === 'undefined') {
      container = document.getElementsByClassName(map_obj.map_container);
    }

    // Get map controls 
    // var launch_directions = document.getElementById('launch-directions');
    var map_clear = document.getElementById('map-clear');

    // Create directions panel 
    var directions_panel = document.createElement('div');
    directions_panel.className = 'directions-panel';

    // Loop through results and add to directions panel
    var moves = result.routes[0].legs[0].steps;
    var html, turn;

    for (var i = 0; i < moves.length; i++) {

      html = '<span class="number">' + (i + 1) + '</span><span class="instruction">' + moves[i].instructions + '</span><span class="duration"> for ' + moves[i].duration.text + ' </span>';
      turn = document.createElement('p');
      turn.innerHTML = html;
      directions_panel.appendChild(turn);
    }

    container.appendChild(directions_panel);

    clear_map(map, display, container);

  }

  function perspective_init() {};

}